import React from 'react';
import { Modal } from 'antd';
import { ExclamationCircleOutlined, DeleteOutlined } from '@ant-design/icons';
import { CancelButton, DeleteButton } from '../../buttons';
import * as S from './DeleteConfirmModal.styles';

export interface DeleteConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  description?: string;
  itemName: string;
  isLoading?: boolean;
  confirmButtonText?: string;
  warningText?: string;
}

export const DeleteConfirmModal: React.FC<DeleteConfirmModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  description,
  itemName,
  isLoading = false,
  confirmButtonText,
  warningText
}) => {
  // Extract item type from title (e.g., "Delete Class" -> "Class", "Delete Student" -> "Student")
  const itemType = title.replace('Delete ', '').toLowerCase();
  const buttonText = confirmButtonText || `Delete ${title.replace('Delete ', '')}`;
  const warning = warningText || `This action cannot be undone. All data associated with this ${itemType} will be permanently deleted.`;
  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      centered
      width={380}
      closable={false}
      maskClosable={!isLoading}
    >
      <S.ModalContent>
        <S.IconContainer>
          <S.WarningIcon>
            <ExclamationCircleOutlined />
          </S.WarningIcon>
        </S.IconContainer>

        <S.ContentSection>
          <S.Title>{title}</S.Title>
          
          <S.ItemName>"{itemName}"</S.ItemName>
          
          {description && (
            <S.Description>{description}</S.Description>
          )}
          
          <S.WarningText>
            {warning}
          </S.WarningText>
        </S.ContentSection>

        <S.ButtonSection>
          <CancelButton 
            onClick={onClose}
            disabled={isLoading}
          >
            Cancel
          </CancelButton>
          
          <DeleteButton 
            onClick={onConfirm}
            disabled={isLoading}
            loading={isLoading}
          >
            {isLoading ? 'Deleting...' : buttonText}
          </DeleteButton>
        </S.ButtonSection>
      </S.ModalContent>
    </Modal>
  );
};
